import { axios } from '@LIBS';
import { Constants } from '@CONFIG';

const updateCompanySettings = async (values) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/settings/update`,
    method: 'PUT',
    data: {
      values,
    },
  });

  return response;
};

export { updateCompanySettings };
